import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import moment from "moment";
import history from "../../../helpers/history";
import formatCurrency from "helpers/formatCurrency";
import { CheckPermissionRender, checkPermission } from "../../../helpers/checkPermission";
import permissions from "../../../config/permissions";
import Author from "components/author";

export default function getAccountsTableData(accounts, onEdit, onTransfer) {
  const AccNo = ({ accNo }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {accNo}
      </MDTypography>
    </MDBox>
  );

  const columns = [
    { Header: "Acc No", accessor: "acc_no", align: "center", minWidth: "40px" },
    { Header: "Name / Address", accessor: "name", align: "left" },
    { Header: "Contact No", accessor: "phone_number", align: "center", minWidth: "70px" },
    { Header: "Last Reading", accessor: "last_reading_date", align: "center", minWidth: "74px" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  if (checkPermission(permissions().payment().read().list())) {
    columns.splice(4, 0, {
      Header: "Current Balance",
      accessor: "balance",
      align: "right",
      minWidth: "100px",
    });
  }

  return {
    columns: columns,
    rows: accounts.map((account) => {
      return {
        name: (
          <Author
            name={account.holder_name}
            address={account.address}
            transfers={account.transfers}
            lateReadings={account.late_readings}
          />
        ),
        acc_no: <AccNo accNo={account.account_number} />,
        balance: (
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            color={account.current_balance >= 0 ? "success" : "error"}
            fontWeight="medium"
          >
            {formatCurrency(account.current_balance)}
          </MDTypography>
        ),
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={account.status}
              color={
                account.status === "ACTIVE"
                  ? "success"
                  : account.status === "SUSPENDED"
                  ? "error"
                  : "warning"
              }
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        last_reading_date: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {account.readings[0]?.createdAt
              ? moment(account.readings[0]?.createdAt).format("YY/MM/DD")
              : "--"}
          </MDTypography>
        ),
        phone_number: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {account.phone_number ? account.phone_number : "--"}
          </MDTypography>
        ),
        action: (
          <>
            <CheckPermissionRender permissions={permissions().account().update().list()}>
              <MDTypography
                mr={1}
                onClick={() => {
                  onEdit(account);
                }}
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                Update
              </MDTypography>
            </CheckPermissionRender>
            <MDTypography
              mr={1}
              onClick={() => {
                history.navigate(`/accounts/${account.id}`);
              }}
              component="a"
              href="#"
              variant="caption"
              color="text"
              fontWeight="medium"
            >
              View
            </MDTypography>
            <CheckPermissionRender permissions={permissions().account().update().list()}>
              <MDTypography
                onClick={() => {
                  onTransfer(account);
                }}
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                Transfer
              </MDTypography>
            </CheckPermissionRender>
          </>
        ),
      };
    }),
  };
}

export const AccountStatuses = {
  ACTIVE: "ACTIVE",
  INPROGRESS: "INPROGRESS",
  SUSPENDED: "SUSPENDED",
};
